let namespace = 'clientCredit_';

const initialState = {
    pagination: {
        pageSize: 5,
        current: 1,
        showSizeChanger: true,
        showQuickJumper:true,
        pageSizeOptions: [
            "5",
            "10",
            "20",
            "40",
            "100"
        ]
    },
    // 搜索参数
    searchProps: {},
    // 加载状态，默认是true
    loading: false,
    // 数据列表
    dataList: [],
}

export default function (state = initialState, action) {
    switch (action.type) {
        case namespace + "forcedUpdate": {
            return {
                ...state,
                ...action.payload
            }
        };
        default : {
            return state;
        }
    }
}